import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { CONFIGURATION_QUERY } from '../../graphql'
import { CONFIG_KEYS } from '../../constants'
import { Alert } from 'reactstrap'

export const CONFIGURATION = gql(CONFIGURATION_QUERY)

export default function LoginMessage() {
  console.log('LoginMessage rendered')

  const { loading, error, data } = useQuery(CONFIGURATION, { variables: { key: CONFIG_KEYS.loginMessage.key } })

  if (error) return `Error! ${error.message}`
  if (loading || !data) return 'Loading...'
  if (data.configuration && data.configuration.value) {
    let loginMessage
    try {
      loginMessage = JSON.parse(data.configuration.value)
    } catch(e) {
      loginMessage = { color: 'danger', text: e.message }
    }
    if (loginMessage.text) {
      return (
        <Alert style={{ textAlign: 'left', whiteSpace: 'pre-wrap' }} color={loginMessage.color} data-cy="login-message">
          <p>{loginMessage.text}</p>
        </Alert>
      )
    }
  }
  return null
}
